import React, { Fragment, Component  } from 'react'
import { Link } from 'react-router-dom'

class Footer extends Component {

   currentYear = () => {
      let dateToday = new Date()
      let currentYear = dateToday.getFullYear()
      return currentYear
    }
    render(){
      return(
        <Fragment>
          <footer className="Footer">
            <section className="container">
            
                <Link to="/">
                <span> afrodesiamedia </span> <span>&copy;
                {this.currentYear()} </span></Link>
              {/*
                <span className="line">|</span>
                <a href="https://afrodesiamedia.com/admin/" className="dev-link"> admin</a>
            */}

                

            </section>
          </footer>
        </Fragment>
      )
    }
}
export default Footer


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/includes/Footer/Footer.js